import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

//Carousel
import Carousel from "react-bootstrap/Carousel";

//logo
import logo1 from "./assete/textile/logo1.png";
import logo2 from "./assete/textile/logo2.png";
import logo3 from "./assete/textile/logo3.png";
//photo
import pic1 from "./assete/textile/pic1.png";
import pic2 from "./assete/textile/pic2.png";
import pic3 from "./assete/textile/pic3.png";
import pic4 from "./assete/textile/pic4.png";
import pic5 from "./assete/textile/pic5.png";
import pic6 from "./assete/textile/pic6.png";
import pic7 from "./assete/textile/pic7.png";
import pic8 from "./assete/textile/pic8.png";

const Textile = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-around",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "15%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "15%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "15%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل و مانیتورینگ خط کشش الیاف و ذوب ریس
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>کارخانه نساجی آسیا (دلیجان)</li>
              <li>شرکت بافتینه پارس درسا (دلیجان)</li>
              <li> کارخانه الیاف ساویس</li>
            </ul>
          </Box>
          <Box component="div" className="text" sx={{ marginTop: "40px" }}>
            <Typography
              sx={{
                fontFamily: "Homa",
                fontSize: "1.15rem",
                marginTop: "15px",
              }}
            >
              <ul>
                <li>
                  نصب و راه اندازی ماشین آلات خطوط تولید نخ ، وارپینگ و دستگاه
                  های بافت گونی چتایی( شرکت پالاز موکت)
                </li>
              </ul>
            </Typography>
          </Box>
          <Box component="div" className="text" sx={{ marginTop: "0px" }}>
            <Typography
              sx={{
                fontFamily: "Homa",
                fontSize: "1.15rem",
                marginTop: "15px",
              }}
            >
              <ul>
                <li>
                  نصب و راه اندازی دستگاه های بافت موکت تافتینگ ،{" "}
                  <span style={{ fontFamily: "roboto", fontSize: "1.2rem" }}>
                    Cut
                  </span>{" "}
                  و
                  <span style={{ fontFamily: "roboto", fontSize: "1.2rem" }}>
                    Loop
                  </span>{" "}
                  و دستگاه های دولاتابی و هیت ست (شرکت پالاز موکت)
                </li>
              </ul>
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            ></ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" sx={{ marginTop: "20px" }}>
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic5} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic6} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic7} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic8} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Textile;
